<template lang="pug">
#home
  .jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0.banner(
    :style="{ backgroundImage: 'url(' + indexInformation.photo.image + ')' }"
  )
    .container
      b-alert.alert.alert-warning.alert-dismissible.fade.show(
        role="alert",
        dismissible,
        show,
        v-show="indexInformation.show_notification"
      ) 
        a(
          style="cursor: pointer",
          @click="notificationClick(indexInformation)",
          v-html="indexInformation.notification"
        )
      .row.align-items-center
        .col
          .p-5
            h4.display-4.text-white {{ indexInformation.slogan }}
            ul
              li(v-for="description in sloganList") {{ description }}
        .col.d-none.d-md-block
          .selector
            h4.text-center.text-white {{ indexInformation.pcap_ic_selector_title }}
            p.text-center {{ indexInformation.pcap_ic_selector_desc }}
            form(@submit="submitForm")
              .form-group
                label(for="inputPanelSize") Panel Size
                  font-awesome-icon.ml-1(
                    v-b-tooltip.hover.right="indexInformation.panel_size_desc",
                    :icon="['fas', 'exclamation-circle']"
                  ) 
                input#inputPanelSize.form-control(
                  v-model="panelSize",
                  :class="{ 'is-invalid': panelSizeStatus }",
                  type="text",
                  placeholder="inches"
                )
              .form-row
                .form-group.col-md-6
                  label(for="inputTx") Active Area X-axis
                    font-awesome-icon.ml-1(
                      v-b-tooltip.hover.right="indexInformation.active_area_tx_desc",
                      :icon="['fas', 'exclamation-circle']"
                    ) 
                  input#inputTx.form-control(
                    v-model="areaX",
                    :class="{ 'is-invalid': areaXStatus }",
                    type="text",
                    placeholder="Area Diameter"
                  )
                .form-group.col-md-6
                  label(for="inputRx") Active Area Y-axis
                  input#inputRx.form-control(
                    v-model="areaY",
                    :class="{ 'is-invalid': areaYStatus }",
                    type="text",
                    placeholder="Area Diameter"
                  )
              .form-row
                .form-group.col-md-6
                  label(for="inputTx2")
                    | Sensing Channels X-axis
                    font-awesome-icon.ml-1(
                      v-b-tooltip.hover.right="indexInformation.channels_tx_desc",
                      :icon="['fas', 'exclamation-circle']"
                    ) 
                  input#inputTx2.form-control(
                    v-model="channelsX",
                    :class="{ 'is-invalid': channelsXStatus }",
                    type="text",
                    placeholder="lines"
                  )
                .form-group.col-md-6
                  label(for="inputRx2") Sensing Channels Y-axis
                  input#inputRx2.form-control(
                    v-model="channelsY",
                    :class="{ 'is-invalid': channelsYStatus }",
                    type="text",
                    placeholder="lines"
                  )
              button.btn.btn-light.btn-block(type="submit") Select
  icon-carousel(
    v-if="indexRapidLinkList && indexRapidLinkList.length > 0",
    :iconList="indexRapidLinkList"
  )
  application-and-cases
  touch-screen-size
  product-type
  banner
  .container.py-5
    .row.article
      article-list(
        v-if="announcementList.length > 0",
        :title="'Announcement'",
        :articleList="announcementList",
        :type="'announcement'"
      )
      article-list(
        v-if="pressReleaseList.length > 0",
        :title="'News'",
        :articleList="pressReleaseList",
        :type="'press_release'"
      )
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
  dialog-text-btn(
    @onDialogTextBtnClick="onDialogTextBtnClick",
    :title="dialogTextBtnData.title",
    :content="dialogTextBtnData.content",
    :btn="dialogTextBtnData.btn"
  )
</template>

<script>
import IconCarousel from "@/components/home/IconCarousel";
import ApplicationAndCases from "@/components/home/ApplicationAndCases";
import ProductType from "@/components/home/ProductType";
import TouchScreenSize from "@/components/home/TouchScreenSize";
import Banner from "@/components/home/Banner";
import ArticleList from "@/components/home/ArticleList";
import Footer from "@/components/home/Footer";
import FloatActions from "@/components/common/FloatActions";
import FloatTop from "@/components/common/FloatTop";
import DialogTextBtn from "@/components/common/DialogTextBtn";
import { getIndexInformation } from "@/api/index";
import { getAnnouncementList, getPressReleaseList } from "@/api/news";
import { searchICSelector } from "@/api/product";
import {
  validIsNumberAndBiggerThanZero,
  validIsIntegerAndBiggerThanZero,
} from "@/utils/validate";
import { getIndexRapidLinkList } from "@/api/index";
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "Home",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  mixins: [mixins],
  components: {
    "icon-carousel": IconCarousel,
    "application-and-cases": ApplicationAndCases,
    "product-type": ProductType,
    "touch-screen-size": TouchScreenSize,
    banner: Banner,
    "article-list": ArticleList,
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    DialogTextBtn,
  },
  data() {
    return {
      dialogTextBtnData: {
        title: "Tips",
        content: "",
        btn: "Keep Going",
      },
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 7,
        spaceBetween: 10,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
      },
      indexInformation: {
        photo: {
          image: "",
        },
      },
      indexRapidLinkList: [],
      sloganList: [],
      announcementList: [],
      pressReleaseList: [],
      closeAlert: false,

      panelSize: "",
      areaX: "",
      areaY: "",
      channelsX: "",
      channelsY: "",
      panelSizeStatus: false,
      areaXStatus: false,
      areaYStatus: false,
      channelsXStatus: false,
      channelsYStatus: false,
      tempData: {},

      metaData: {
        title: "EETI ｜Professional TouchScreen Controller Design",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    initialLanguage() {
      this.sloganList = [];
      this.getIndexInformation();
      this.getIndexRapidLinkList();
      this.getAnnouncementList();
      this.getPressReleaseList();
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    getIndexInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getIndexInformation(temp).then((response) => {
        this.indexInformation = response.data;
        if (this.indexInformation.pcap_ic_selector_slogan_1) {
          this.sloganList.push(this.indexInformation.pcap_ic_selector_slogan_1);
        }
        if (this.indexInformation.pcap_ic_selector_slogan_2) {
          this.sloganList.push(this.indexInformation.pcap_ic_selector_slogan_2);
        }
        if (this.indexInformation.pcap_ic_selector_slogan_3) {
          this.sloganList.push(this.indexInformation.pcap_ic_selector_slogan_3);
        }
        if (this.indexInformation.pcap_ic_selector_slogan_4) {
          this.sloganList.push(this.indexInformation.pcap_ic_selector_slogan_4);
        }
      });
    },
    getAnnouncementList() {
      let params = { lang: this.$store.state.user.language, is_index: true };
      getAnnouncementList(params).then((response) => {
        this.announcementList = response.data;
      });
    },
    getPressReleaseList() {
      let params = { lang: this.$store.state.user.language, is_index: true };
      getPressReleaseList(params).then((response) => {
        this.pressReleaseList = response.data;
      });
    },
    getIndexRapidLinkList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getIndexRapidLinkList(temp).then((response) => {
        this.indexRapidLinkList = response.data;
      });
    },
    submitForm(e) {
      e.preventDefault();

      if (validIsNumberAndBiggerThanZero(this.panelSize)) {
        this.panelSizeStatus = false;
      } else {
        this.panelSizeStatus = true;
      }

      if (validIsNumberAndBiggerThanZero(this.areaX)) {
        this.areaXStatus = false;
      } else {
        this.areaXStatus = true;
      }

      if (validIsNumberAndBiggerThanZero(this.areaY)) {
        this.areaYStatus = false;
      } else {
        this.areaYStatus = true;
      }

      if (validIsIntegerAndBiggerThanZero(this.channelsX)) {
        this.channelsXStatus = false;
      } else {
        this.channelsXStatus = true;
      }

      if (validIsIntegerAndBiggerThanZero(this.channelsY)) {
        this.channelsYStatus = false;
      } else {
        this.channelsYStatus = true;
      }

      if (
        !this.panelSizeStatus &&
        !this.areaXStatus &&
        !this.areaYStatus &&
        !this.channelsXStatus &&
        !this.channelsYStatus
      ) {
        let data = {
          panel_size: this.panelSize,
          active_area_x: this.areaX,
          active_area_y: this.areaY,
          channel_x: this.channelsX,
          channel_y: this.channelsY,
          lang: this.$store.state.user.language,
        };
        this.tempData = data;
        searchICSelector(data).then((response) => {
          let result = response.data;
          if (result.warnings && result.warnings.length > 0) {
            this.dialogTextBtnData.content = "";
            for (let x in result.warnings) {
              let tmp = result.warnings[x];
              this.dialogTextBtnData.content =
                this.dialogTextBtnData.content + tmp;
              if (result.warnings.length > x + 1) {
                this.dialogTextBtnData.content =
                  this.dialogTextBtnData.content + "<br>";
              }
            }
            this.showTextBtnDialog();
          } else {
            this.$router.push({ name: "IcSelector", query: this.tempData });
          }
        });
      }
    },
    showTextBtnDialog() {
      this.$bvModal.show("textBtnModal");
    },
    onDialogTextBtnClick() {
      this.$bvModal.hide("textBtnModal");
      this.$router.push({ name: "IcSelector", query: this.tempData });
    },
    notificationClick(notification) {
      this.linkClick(notification.notification_link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/home";
</style>
